
import React from 'react'
import css from './ReceiptInfo.module.css'
import moment from 'moment'

const ReceiptInfo = props => (
  <div className={css.main}>
    <table>
      <tr>
        <th>Date</th>
        <td>{moment(props.date).format('MMM Do, YYYY')}</td>
      </tr>
      <tr>
        <th>Charge ID</th>
        <td>{props.id}</td>
      </tr>
      <tr>
        <th>Credit Card ending in</th>
        <td>{props.card.last4}</td>
      </tr>
      <tr>
        <th>Bill to</th>
        <td>Segment</td>
      </tr>
      <tr>
        <th>Details</th>
        <td><a href={`https://segment.com/${props.workspaceSlug}/settings/billing/payments`}>{`https://segment.com/${props.workspaceSlug}/settings/billing/payments`}</a></td>
      </tr>
    </table>
    {props.extra ? <span className={css.extra}>{props.extra}</span> : null}
  </div>
)

export default ReceiptInfo



// WEBPACK FOOTER //
// ./components/ReceiptInfo.js